/*
 * @Description:
 * @Version: 2.0
 * @Autor: shimnx
 * @Date: 2021-08-04 09:07:37
 * @LastEditors: shimnx
 * @LastEditTime: 2021-08-04 11:10:21
 */
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap, delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(public translate: TranslateService, private router: Router) {}
  isLoggedIn = true;

  // store the URL so we can redirect after logging in
  redirectUrl: string;

  login(): Observable<boolean> {
    return of(true).pipe(
      delay(1000),
      tap((val) => (this.isLoggedIn = true))
    );
  }

  logout(): void {
    this.isLoggedIn = false;
    this.router.navigateByUrl('/login');
  }
}

/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
